// src/components/OccupationSelect.js

import React from "react";

var occupations = [
    {code:"11-1011",text:"Chief Executives"},
    {code:"11-1031",text:"Legislators"},
    {code:"11-2011",text:"Advertising and Promotions Managers"},
    {code:"11-2031",text:"Public Relations and Fundraising Managers"},
    {code:"11-3031",text:"Financial Managers"},
    {code:"11-3051",text:"Industrial Production Managers"},
    {code:"11-3071",text:"Transportation, Storage, and Distribution Managers"},
    {code:"11-9021",text:"Construction Managers"},
    {code:"11-9041",text:"Architectural and Engineering Managers"},
    {code:"11-9071",text:"Gaming Managers"},
    {code:"11-9141",text:"Property, Real Estate, and Community Association M"},
    {code:"13-1011",text:"Agents and Business Managers of Artists, Performer"},
    {code:"13-1041",text:"Compliance Officers"},
    {code:"13-1131",text:"Fundraisers"},
    {code:"13-2011",text:"Accountants and Auditors"},
    {code:"13-2021",text:"Appraisers and Assessors of Real Estate"},
    {code:"13-2051",text:"Financial Analysts"},
    {code:"13-2052",text:"Personal Financial Advisors"},
    {code:"13-2053",text:"Insurance Underwriters"},
    {code:"13-2061",text:"Financial Examiners"},
    {code:"13-2081",text:"Tax Examiners and Collectors, and Revenue Agents"},
    {code:"13-2082",text:"Tax Preparers"},
    {code:"13-2099",text:"Financial Specialists, All Other"},
    {code:"17-2051",text:"Civil Engineers"},
    {code:"17-2151",text:"Mining and Geological Engineers, Including Mining"},
    {code:"17-2161",text:"Nuclear Engineers"},
    {code:"17-2171",text:"Petroleum Engineers"},
    {code:"17-2199",text:"Engineers, All Other"},
    {code:"19-1041",text:"Epidemiologists"},
    {code:"19-2042",text:"Geoscientists, Except Hydrologists and Geographers"},
    {code:"19-3011",text:"Economists"},
    {code:"19-4041",text:"Geological and Petroleum Technicians"},
    {code:"19-4051",text:"Nuclear Technicians"},
    {code:"23-1011",text:"Lawyers"},
    {code:"23-1021",text:"Administrative Law Judges, Adjudicators, and Heari"},
    {code:"23-1023",text:"Judges, Magistrate Judges, and Magistrates"},
    {code:"25-4012",text:"Curators"},
    {code:"27-1011",text:"Art Directors"},
    {code:"27-1012",text:"Craft Artists"},
    {code:"27-1013",text:"Fine Artists, Including Painters, Sculptors, and I"},
    {code:"27-1019",text:"Artists and Related Workers, All Other"},
    {code:"27-1021",text:"Commercial and Industrial Designers"},
    {code:"27-2012",text:"Producers and Directors"},
    {code:"27-2021",text:"Athletes and Sports Competitors"},
    {code:"27-2022",text:"Coaches and Scouts"},
    {code:"27-2023",text:"Umpires, Referees, and Other Sports Officials"},
    {code:"27-2031",text:"Dancers"},
    {code:"27-2042",text:"Musicians and Singers"},
    {code:"27-4021",text:"Photographers"},
    {code:"29-1011",text:"Chiropractors"},
    {code:"29-1021",text:"Dentists, General"},
    {code:"29-1022",text:"Oral and Maxillofacial Surgeons"},
    {code:"29-1023",text:"Orthodontists"},
    {code:"29-1024",text:"Prosthodontists"},
    {code:"29-1029",text:"Dentists, All Other Specialists"},
    {code:"29-1041",text:"Optometrists"},
    {code:"29-1061",text:"Anesthesiologists"},
    {code:"29-1062",text:"Family and General Practitioners"},
    {code:"29-1063",text:"Internists, General"},
    {code:"29-1064",text:"Obstetricians and Gynecologists"},
    {code:"29-1065",text:"Pediatricians, General"},
    {code:"29-1066",text:"Psychiatrists"},
    {code:"29-1067",text:"Surgeons"},
    {code:"29-1069",text:"Physicians and Surgeons, All Other"},
    {code:"29-1081",text:"Podiatrists"},
    {code:"29-1131",text:"Veterinarians"},
    {code:"29-1199",text:"Health Diagnosing and Treating Practitioners, All"},
    {code:"29-2081",text:"Opticians, Dispensing"},
    {code:"29-2091",text:"Orthotists and Prosthetists"},
    {code:"31-9097",text:"Phlebotomists"},
    {code:"33-9021",text:"Private Detectives and Investigators"},
    {code:"33-9031",text:"Gaming Surveillance Officers and Gaming Investigat"},
    {code:"35-1011",text:"Chefs and Head Cooks"},
    {code:"35-3011",text:"Bartenders"},
    {code:"39-1011",text:"Gaming Supervisors"},
    {code:"39-3011",text:"Gaming Dealers"},
    {code:"39-3012",text:"Gaming and Sports Book Writers and Runners"},
    {code:"39-3019",text:"Gaming Service Workers, All Other"},
    {code:"39-4011",text:"Embalmers"},
    {code:"41-2011",text:"Cashiers"},
    {code:"41-2012",text:"Gaming Change Persons and Booth Cashiers"},
    {code:"41-3021",text:"Insurance Sales Agents"},
    {code:"41-3031",text:"Securities, Commodities, and Financial Services Sa"},
    {code:"41-3041",text:"Travel Agents"},
    {code:"41-9012",text:"Models"},
    {code:"41-9021",text:"Real Estate Brokers"},
    {code:"41-9022",text:"Real Estate Sales Agents"},
    {code:"43-3041",text:"Gaming Cage Workers"},
    {code:"43-3071",text:"Tellers"},
    {code:"43-3099",text:"Financial Clerks, All Other"},
    {code:"43-4011",text:"Brokerage Clerks"},
    {code:"43-4181",text:"Reservation and Transportation Ticket Agents and T"},
    {code:"43-5011",text:"Cargo and Freight Agents"},
    {code:"43-5081",text:"Stock Clerks and Order Fillers"},
    {code:"43-9041",text:"Insurance Claims and Policy Processing Clerks"},
    {code:"45-2021",text:"Animal Breeders"},
    {code:"47-1011",text:"First-Line Supervisors of Construction Trades and"},
    {code:"47-2061",text:"Construction Laborers"},
    {code:"47-2071",text:"Paving, Surfacing, and Tamping Equipment Operators"},
    {code:"47-2073",text:"Operating Engineers and Other Construction Equipme"},
    {code:"47-2141",text:"Painters, Construction and Maintenance"},
    {code:"47-2152",text:"Plumbers, Pipefitters, and Steamfitters"},
    {code:"47-4011",text:"Construction and Building Inspectors"},
    {code:"47-4099",text:"Construction and Related Workers, All Other"},
    {code:"47-5011",text:"Derrick Operators, Oil and Gas"},
    {code:"47-5012",text:"Rotary Drill Operators, Oil and Gas"},
    {code:"47-5013",text:"Service Unit Operators, Oil, Gas, and Mining"},
    {code:"47-5021",text:"Earth Drillers, Except Oil and Gas"},
    {code:"47-5031",text:"Explosives Workers, Ordnance Handling Experts, and"},
    {code:"47-5041",text:"Continuous Mining Machine Operators"},
    {code:"47-5049",text:"Mining Machine Operators, All Other"},
    {code:"47-5061",text:"Roof Bolters, Mining"},
    {code:"47-5071",text:"Roustabouts, Oil and Gas"},
    {code:"47-5099",text:"Extraction Workers, All Other"},
    {code:"49-2011",text:"Computer, Automated Teller, and Office Machine Rep"},
    {code:"49-2092",text:"Electric Motor, Power Tool, and Related Repairers"},
    {code:"49-9064",text:"Watch Repairers"},
    {code:"49-9091",text:"Coin, Vending, and Amusement Machine Servicers and"},
    {code:"51-4032",text:"Drilling and Boring Machine Tool Setters, Operator"},
    {code:"51-8011",text:"Nuclear Power Reactor Operators"},
    {code:"51-8092",text:"Gas Plant Operators"},
    {code:"51-8093",text:"Petroleum Pump System Operators, Refinery Operator"},
    {code:"51-9071",text:"Jewelers and Precious Stone and Metal Workers"},
    {code:"53-1011",text:"Aircraft Cargo Handling Supervisors"},
    {code:"53-2011",text:"Airline Pilots, Copilots, and Flight Engineers"},
    {code:"53-2012",text:"Commercial Pilots"},
    {code:"53-2031",text:"Flight Attendants"},
    {code:"53-3032",text:"Heavy and Tractor-Trailer Truck Drivers"},
    {code:"53-5011",text:"Sailors and Marine Oilers"},
    {code:"53-5021",text:"Captains, Mates, and Pilots of Water Vessels"},
    {code:"53-5022",text:"Motorboat Operators"},
    {code:"53-6061",text:"Transportation Attendants, Except Flight Attendant"},
    {code:"53-6099",text:"Transportation Workers, All Other"},
    {code:"53-7033",text:"Loading Machine Operators, Underground Mining"},
    {code:"53-7041",text:"Hoist and Winch Operators"},
    {code:"53-7062",text:"Laborers and Freight, Stock, and Material Movers,"},
    {code:"53-7071",text:"Gas Compressor and Gas Pumping Station Operators"},
    {code:"53-7111",text:"Mine Shuttle Car Operators"},
    {code:"53-7121",text:"Tank Car, Truck, and Ship Loaders"},
    {code:"55-1011",text:"Air Crew Officers"},
    {code:"55-1016",text:"Infantry Officers"},
    {code:"55-1017",text:"Special Forces Officers"},
    {code:"55-1019",text:"Military Officer Special and Tactical Operations L"},
    {code:"55-2011",text:"First-Line Supervisors of Air Crew Members"},
    {code:"55-3011",text:"Air Crew Members"},
    {code:"55-3016",text:"Infantry"},
    {code:"55-3018",text:"Special Forces"},
    {code:"55-3019",text:"Military Enlisted Tactical Operations and Air\/Weap"},
    {code:"SELFEMP",text:"Self-Employee"},
    {code:"OTHERXX",text:"Other"},
    {code:"UNEMPLO",text:"Unemployed"},
    {code:"15-1121",text:"Computer Systems Analysts"},
    {code:"15-1131",text:"Computer Programmers"},
    {code:"15-1132",text:"Software Developers, Applications"},
    {code:"15-1133",text:"Software Developers, Systems Software"},
    {code:"15-1134",text:"Web Developers"},
    {code:"15-1141",text:"Database Administrators"},
    {code:"15-1199",text:"Computer Occupations, All Other"},
    {code:"23-2011",text:"Paralegals and Legal Assistants"},
    {code:"27-2099",text:"Entertainers and Performers, Sports and Related Wo"},
    {code:"33-3021",text:"Detectives and Criminal Investigators"},
    {code:"51-4121",text:"Welders, Cutters, Solderers, and Brazers"},
    {code:"51-4122",text:"Welding, Soldering, and Brazing Machine Setters, O"},
    {code:"53-3041",text:"Taxi Drivers and Chauffeurs"},
    {code:"53-7073",text:"Wellhead Pumpers"},
    {code:"11-1021",text:"General and Operations Managers"},
    {code:"11-2021",text:"Marketing Managers"},
    {code:"11-2022",text:"Sales Managers"},
    {code:"11-3011",text:"Administrative Services Managers"},
    {code:"11-3021",text:"Computer and Information Systems Managers"},
    {code:"11-3061",text:"Purchasing Managers"},
    {code:"11-3111",text:"Compensation and Benefits Managers"},
    {code:"11-3121",text:"Human Resources Managers"},
    {code:"11-3131",text:"Training and Development Managers"},
    {code:"11-9013",text:"Farmers, Ranchers, and Other Agricultural Managers"},
    {code:"11-9031",text:"Education Administrators, Preschool and Childcare"},
    {code:"11-9032",text:"Education Administrators, Elementary and Secondary"},
    {code:"11-9033",text:"Education Administrators, Postsecondary"},
    {code:"11-9039",text:"Education Administrators, All Other"},
    {code:"11-9051",text:"Food Service Managers"},
    {code:"11-9061",text:"Funeral Service Managers"},
    {code:"11-9081",text:"Lodging Managers"},
    {code:"11-9111",text:"Medical and Health Services Managers"},
    {code:"11-9121",text:"Natural Sciences Managers"},
    {code:"11-9131",text:"Postmasters and Mail Superintendents"},
    {code:"11-9151",text:"Social and Community Service Managers"},
    {code:"11-9161",text:"Emergency Management Directors"},
    {code:"11-9199",text:"Managers, All Other"},
    {code:"13-1021",text:"Buyers and Purchasing Agents, Farm Products"},
    {code:"13-1022",text:"Wholesale and Retail Buyers, Except Farm Products"},
    {code:"13-1023",text:"Purchasing Agents, Except Wholesale, Retail, and F"},
    {code:"13-1031",text:"Claims Adjusters, Examiners, and Investigators"},
    {code:"13-1032",text:"Insurance Appraisers, Auto Damage"},
    {code:"13-1051",text:"Cost Estimators"},
    {code:"13-1071",text:"Human Resources Specialists"},
    {code:"13-1074",text:"Farm Labor Contractors"},
    {code:"13-1075",text:"Labor Relations Specialists"},
    {code:"13-1081",text:"Logisticians"},
    {code:"13-1111",text:"Management Analysts"},
    {code:"13-1121",text:"Meeting, Convention, and Event Planners"},
    {code:"13-1141",text:"Compensation, Benefits, and Job Analysis Specialis"},
    {code:"13-1151",text:"Training and Development Specialists"},
    {code:"13-1161",text:"Market Research Analysts and Marketing Specialists"},
    {code:"13-1199",text:"Business Operations Specialists, All Other"},
    {code:"13-2031",text:"Budget Analysts"},
    {code:"13-2041",text:"Credit Analysts"},
    {code:"13-2071",text:"Credit Counselors"},
    {code:"13-2072",text:"Loan Officers"},
    {code:"15-1111",text:"Computer and Information Research Scientists"},
    {code:"15-1122",text:"Information Security Analysts"},
    {code:"15-1142",text:"Network and Computer Systems Administrators"},
    {code:"15-1143",text:"Computer Network Architects"},
    {code:"15-1151",text:"Computer User Support Specialists"},
    {code:"15-1152",text:"Computer Network Support Specialists"},
    {code:"15-2011",text:"Actuaries"},
    {code:"15-2021",text:"Mathematicians"},
    {code:"15-2031",text:"Operations Research Analysts"},
    {code:"15-2041",text:"Statisticians"},
    {code:"15-2091",text:"Mathematical Technicians"},
    {code:"15-2099",text:"Mathematical Science Occupations, All Other"},
    {code:"17-1011",text:"Architects, Except Landscape and Naval"},
    {code:"17-1012",text:"Landscape Architects"},
    {code:"17-1021",text:"Cartographers and Photogrammetrists"},
    {code:"17-1022",text:"Surveyors"},
    {code:"17-2011",text:"Aerospace Engineers"},
    {code:"17-2021",text:"Agricultural Engineers"},
    {code:"17-2031",text:"Biomedical Engineers"},
    {code:"17-2041",text:"Chemical Engineers"},
    {code:"17-2061",text:"Computer Hardware Engineers"},
    {code:"17-2071",text:"Electrical Engineers"},
    {code:"17-2072",text:"Electronics Engineers, Except Computer"},
    {code:"17-2081",text:"Environmental Engineers"},
    {code:"17-2111",text:"Health and Safety Engineers, Except Mining Safety"},
    {code:"17-2112",text:"Industrial Engineers"},
    {code:"17-2121",text:"Marine Engineers and Naval Architects"},
    {code:"17-2131",text:"Materials Engineers"},
    {code:"17-2141",text:"Mechanical Engineers"},
    {code:"17-3011",text:"Architectural and Civil Drafters"},
    {code:"17-3012",text:"Electrical and Electronics Drafters"},
    {code:"17-3013",text:"Mechanical Drafters"},
    {code:"17-3019",text:"Drafters, All Other"},
    {code:"17-3021",text:"Aerospace Engineering and Operations Technicians"},
    {code:"17-3022",text:"Civil Engineering Technicians"},
    {code:"17-3023",text:"Electrical and Electronics Engineering Technicians"},
    {code:"17-3024",text:"Electro-Mechanical Technicians"},
    {code:"17-3025",text:"Environmental Engineering Technicians"},
    {code:"17-3026",text:"Industrial Engineering Technicians"},
    {code:"17-3027",text:"Mechanical Engineering Technicians"},
    {code:"17-3029",text:"Engineering Technicians, Except Drafters, All Othe"},
    {code:"17-3031",text:"Surveying and Mapping Technicians"},
    {code:"19-1011",text:"Animal Scientists"},
    {code:"19-1012",text:"Food Scientists and Technologists"},
    {code:"19-1013",text:"Soil and Plant Scientists"},
    {code:"19-1021",text:"Biochemists and Biophysicists"},
    {code:"19-1022",text:"Microbiologists"},
    {code:"19-1023",text:"Zoologists and Wildlife Biologists"},
    {code:"19-1029",text:"Biological Scientists, All Other"},
    {code:"19-1031",text:"Conservation Scientists"},
    {code:"19-1032",text:"Foresters"},
    {code:"19-1042",text:"Medical Scientists, Except Epidemiologists"},
    {code:"19-1099",text:"Life Scientists, All Other"},
    {code:"19-2011",text:"Astronomers"},
    {code:"19-2012",text:"Physicists"},
    {code:"19-2021",text:"Atmospheric and Space Scientists"},
    {code:"19-2031",text:"Chemists"},
    {code:"19-2032",text:"Materials Scientists"},
    {code:"19-2041",text:"Environmental Scientists and Specialists, Includin"},
    {code:"19-2043",text:"Hydrologists"},
    {code:"19-2099",text:"Physical Scientists, All Other"},
    {code:"19-3022",text:"Survey Researchers"},
    {code:"19-3031",text:"Clinical, Counseling, and School Psychologists"},
    {code:"19-3032",text:"Industrial-Organizational Psychologists"},
    {code:"19-3039",text:"Psychologists, All Other"},
    {code:"19-3041",text:"Sociologists"},
    {code:"19-3051",text:"Urban and Regional Planners"},
    {code:"19-3091",text:"Anthropologists and Archeologists"},
    {code:"19-3092",text:"Geographers"},
    {code:"19-3093",text:"Historians"},
    {code:"19-3094",text:"Political Scientists"},
    {code:"19-3099",text:"Social Scientists and Related Workers, All Other"},
    {code:"19-4011",text:"Agricultural and Food Science Technicians"},
    {code:"19-4021",text:"Biological Technicians"},
    {code:"19-4031",text:"Chemical Technicians"},
    {code:"19-4061",text:"Social Science Research Assistants"},
    {code:"19-4091",text:"Environmental Science and Protection Technicians,"},
    {code:"19-4092",text:"Forensic Science Technicians"},
    {code:"19-4093",text:"Forest and Conservation Technicians"},
    {code:"19-4099",text:"Life, Physical, and Social Science Technicians, Al"},
    {code:"21-1011",text:"Substance Abuse and Behavioral Disorder Counselors"},
    {code:"21-1012",text:"Educational, Guidance, School, and Vocational Coun"},
    {code:"21-1013",text:"Marriage and Family Therapists"},
    {code:"21-1014",text:"Mental Health Counselors"},
    {code:"21-1015",text:"Rehabilitation Counselors"},
    {code:"21-1019",text:"Counselors, All Other"},
    {code:"21-1021",text:"Child, Family, and School Social Workers"},
    {code:"21-1022",text:"Healthcare Social Workers"},
    {code:"21-1023",text:"Mental Health and Substance Abuse Social Workers"},
    {code:"21-1029",text:"Social Workers, All Other"},
    {code:"21-1091",text:"Health Educators"},
    {code:"21-1092",text:"Probation Officers and Correctional Treatment Spec"},
    {code:"21-1093",text:"Social and Human Service Assistants"},
    {code:"21-1094",text:"Community Health Workers"},
    {code:"21-1099",text:"Community and Social Service Specialists, All Othe"},
    {code:"21-2011",text:"Clergy"},
    {code:"21-2021",text:"Directors, Religious Activities and Education"},
    {code:"21-2099",text:"Religious Workers, All Other"},
    {code:"23-1012",text:"Judicial Law Clerks"},
    {code:"23-1022",text:"Arbitrators, Mediators, and Conciliators"},
    {code:"23-2091",text:"Court Reporters"},
    {code:"23-2093",text:"Title Examiners, Abstractors, and Searchers"},
    {code:"23-2099",text:"Legal Support Workers, All Other"},
    {code:"25-1011",text:"Business Teachers, Postsecondary"},
    {code:"25-1021",text:"Computer Science Teachers, Postsecondary"},
    {code:"25-1022",text:"Mathematical Science Teachers, Postsecondary"},
    {code:"25-1031",text:"Architecture Teachers, Postsecondary"},
    {code:"25-1032",text:"Engineering Teachers, Postsecondary"},
    {code:"25-1041",text:"Agricultural Sciences Teachers, Postsecondary"},
    {code:"25-1042",text:"Biological Science Teachers, Postsecondary"},
    {code:"25-1043",text:"Forestry and Conservation Science Teachers, Postse"},
    {code:"25-1051",text:"Atmospheric, Earth, Marine, and Space Sciences Tea"},
    {code:"25-1052",text:"Chemistry Teachers, Postsecondary"},
    {code:"25-1053",text:"Environmental Science Teachers, Postsecondary"},
    {code:"25-1054",text:"Physics Teachers, Postsecondary"},
    {code:"25-1061",text:"Anthropology and Archeology Teachers, Postsecondar"},
    {code:"25-1062",text:"Area, Ethnic, and Cultural Studies Teachers, Posts"},
    {code:"25-1063",text:"Economics Teachers, Postsecondary"},
    {code:"25-1064",text:"Geography Teachers, Postsecondary"},
    {code:"25-1065",text:"Political Science Teachers, Postsecondary"},
    {code:"25-1066",text:"Psychology Teachers, Postsecondary"},
    {code:"25-1067",text:"Sociology Teachers, Postsecondary"},
    {code:"25-1069",text:"Social Sciences Teachers, Postsecondary, All Other"},
    {code:"25-1071",text:"Health Specialties Teachers, Postsecondary"},
    {code:"25-1072",text:"Nursing Instructors and Teachers, Postsecondary"},
    {code:"25-1081",text:"Education Teachers, Postsecondary"},
    {code:"25-1082",text:"Library Science Teachers, Postsecondary"},
    {code:"25-1111",text:"Criminal Justice and Law Enforcement Teachers, Pos"},
    {code:"25-1112",text:"Law Teachers, Postsecondary"},
    {code:"25-1113",text:"Social Work Teachers, Postsecondary"},
    {code:"25-1121",text:"Art, Drama, and Music Teachers, Postsecondary"},
    {code:"25-1122",text:"Communications Teachers, Postsecondary"},
    {code:"25-1123",text:"English Language and Literature Teachers, Postseco"},
    {code:"25-1124",text:"Foreign Language and Literature Teachers, Postseco"},
    {code:"25-1125",text:"History Teachers, Postsecondary"},
    {code:"25-1126",text:"Philosophy and Religion Teachers, Postsecondary"},
    {code:"25-1191",text:"Graduate Teaching Assistants"},
    {code:"25-1192",text:"Home Economics Teachers, Postsecondary"},
    {code:"25-1193",text:"Recreation and Fitness Studies Teachers, Postsecon"},
    {code:"25-1194",text:"Vocational Education Teachers, Postsecondary"},
    {code:"25-1199",text:"Postsecondary Teachers, All Other"},
    {code:"25-2011",text:"Preschool Teachers, Except Special Education"},
    {code:"25-2012",text:"Kindergarten Teachers, Except Special Education"},
    {code:"25-2021",text:"Elementary School Teachers, Except Special Educati"},
    {code:"25-2022",text:"Middle School Teachers, Except Special and Career\/"},
    {code:"25-2023",text:"Career\/Technical Education Teachers, Middle School"},
    {code:"25-2031",text:"Secondary School Teachers, Except Special and Care"},
    {code:"25-2032",text:"Career\/Technical Education Teachers, Secondary Sch"},
    {code:"25-2051",text:"Special Education Teachers, Preschool"},
    {code:"25-2052",text:"Special Education Teachers, Kindergarten and Eleme"},
    {code:"25-2053",text:"Special Education Teachers, Middle School"},
    {code:"25-2054",text:"Special Education Teachers, Secondary School"},
    {code:"25-2059",text:"Special Education Teachers, All Other"},
    {code:"25-3011",text:"Adult Basic and Secondary Education and Literacy T"},
    {code:"25-3021",text:"Self-Enrichment Education Teachers"},
    {code:"25-3099",text:"Teachers and Instructors, All Other"},
    {code:"25-4011",text:"Archivists"},
    {code:"25-4013",text:"Museum Technicians and Conservators"},
    {code:"25-4021",text:"Librarians"},
    {code:"25-4031",text:"Library Technicians"},
    {code:"25-9011",text:"Audio-Visual and Multimedia Collections Specialist"},
    {code:"25-9021",text:"Farm and Home Management Advisors"},
    {code:"25-9031",text:"Instructional Coordinators"},
    {code:"25-9041",text:"Teacher Assistants"},
    {code:"25-9099",text:"Education, Training, and Library Workers, All Othe"},
    {code:"27-1014",text:"Multimedia Artists and Animators"},
    {code:"27-1022",text:"Fashion Designers"},
    {code:"27-1023",text:"Floral Designers"},
    {code:"27-1024",text:"Graphic Designers"},
    {code:"27-1025",text:"Interior Designers"},
    {code:"27-1026",text:"Merchandise Displayers and Window Trimmers"},
    {code:"27-1027",text:"Set and Exhibit Designers"},
    {code:"27-1029",text:"Designers, All Other"},
    {code:"27-2011",text:"Actors"},
    {code:"27-2032",text:"Choreographers"},
    {code:"27-2041",text:"Music Directors and Composers"},
    {code:"27-3011",text:"Radio and Television Announcers"},
    {code:"27-3012",text:"Public Address System and Other Announcers"},
    {code:"27-3021",text:"Broadcast News Analysts"},
    {code:"27-3022",text:"Reporters and Correspondents"},
    {code:"27-3031",text:"Public Relations Specialists"},
    {code:"27-3041",text:"Editors"},
    {code:"27-3042",text:"Technical Writers"},
    {code:"27-3043",text:"Writers and Authors"},
    {code:"27-3091",text:"Interpreters and Translators"},
    {code:"27-3099",text:"Media and Communication Workers, All Other"},
    {code:"27-4011",text:"Audio and Video Equipment Technicians"},
    {code:"27-4012",text:"Broadcast Technicians"},
    {code:"27-4013",text:"Radio Operators"},
    {code:"27-4014",text:"Sound Engineering Technicians"},
    {code:"27-4031",text:"Camera Operators, Television, Video, and Motion Pi"},
    {code:"27-4032",text:"Film and Video Editors"},
    {code:"27-4099",text:"Media and Communication Equipment Workers, All Oth"},
    {code:"29-1031",text:"Dietitians and Nutritionists"},
    {code:"29-1051",text:"Pharmacists"},
    {code:"29-1071",text:"Physician Assistants"},
    {code:"29-1122",text:"Occupational Therapists"},
    {code:"29-1123",text:"Physical Therapists"},
    {code:"29-1124",text:"Radiation Therapists"},
    {code:"29-1125",text:"Recreational Therapists"},
    {code:"29-1126",text:"Respiratory Therapists"},
    {code:"29-1127",text:"Speech-Language Pathologists"},
    {code:"29-1128",text:"Exercise Physiologists"},
    {code:"29-1129",text:"Therapists, All Other"},
    {code:"29-1141",text:"Registered Nurses"},
    {code:"29-1151",text:"Nurse Anesthetists"},
    {code:"29-1161",text:"Nurse Midwives"},
    {code:"29-1171",text:"Nurse Practitioners"},
    {code:"29-1181",text:"Audiologists"},
    {code:"29-2011",text:"Medical and Clinical Laboratory Technologists"},
    {code:"29-2012",text:"Medical and Clinical Laboratory Technicians"},
    {code:"29-2021",text:"Dental Hygienists"},
    {code:"29-2031",text:"Cardiovascular Technologists and Technicians"},
    {code:"29-2032",text:"Diagnostic Medical Sonographers"},
    {code:"29-2033",text:"Nuclear Medicine Technologists"},
    {code:"29-2034",text:"Radiologic Technologists"},
    {code:"29-2035",text:"Magnetic Resonance Imaging Technologists"},
    {code:"29-2041",text:"Emergency Medical Technicians and Paramedics"},
    {code:"29-2051",text:"Dietetic Technicians"},
    {code:"29-2052",text:"Pharmacy Technicians"},
    {code:"29-2053",text:"Psychiatric Technicians"},
    {code:"29-2054",text:"Respiratory Therapy Technicians"},
    {code:"29-2055",text:"Surgical Technologists"},
    {code:"29-2056",text:"Veterinary Technologists and Technicians"},
    {code:"29-2057",text:"Ophthalmic Medical Technicians"},
    {code:"29-2061",text:"Licensed Practical and Licensed Vocational Nurses"},
    {code:"29-2071",text:"Medical Records and Health Information Technicians"},
    {code:"29-2092",text:"Hearing Aid Specialists"},
    {code:"29-2099",text:"Health Technologists and Technicians, All Other"},
    {code:"29-9011",text:"Occupational Health and Safety Specialists"},
    {code:"29-9012",text:"Occupational Health and Safety Technicians"},
    {code:"29-9091",text:"Athletic Trainers"},
    {code:"29-9092",text:"Genetic Counselors"},
    {code:"29-9099",text:"Healthcare Practitioners and Technical Workers, Al"},
    {code:"31-1011",text:"Home Health Aides"},
    {code:"31-1013",text:"Psychiatric Aides"},
    {code:"31-1014",text:"Nursing Assistants"},
    {code:"31-1015",text:"Orderlies"},
    {code:"31-2011",text:"Occupational Therapy Assistants"},
    {code:"31-2012",text:"Occupational Therapy Aides"},
    {code:"31-2021",text:"Physical Therapist Assistants"},
    {code:"31-2022",text:"Physical Therapist Aides"},
    {code:"31-9011",text:"Massage Therapists"},
    {code:"31-9091",text:"Dental Assistants"},
    {code:"31-9092",text:"Medical Assistants"},
    {code:"31-9093",text:"Medical Equipment Preparers"},
    {code:"31-9094",text:"Medical Transcriptionists"},
    {code:"31-9095",text:"Pharmacy Aides"},
    {code:"31-9096",text:"Veterinary Assistants and Laboratory Animal Careta"},
    {code:"31-9099",text:"Healthcare Support Workers, All Other"},
    {code:"33-1011",text:"First-Line Supervisors of Correctional Officers"},
    {code:"33-1012",text:"First-Line Supervisors of Police and Detectives"},
    {code:"33-1021",text:"First-Line Supervisors of Fire Fighting and Preven"},
    {code:"33-1099",text:"First-Line Supervisors of Protective Service Worke"},
    {code:"33-2011",text:"Firefighters"},
    {code:"33-2021",text:"Fire Inspectors and Investigators"},
    {code:"33-2022",text:"Forest Fire Inspectors and Prevention Specialists"},
    {code:"33-3011",text:"Bailiffs"},
    {code:"33-3012",text:"Correctional Officers and Jailers"},
    {code:"33-3031",text:"Fish and Game Wardens"},
    {code:"33-3041",text:"Parking Enforcement Workers"},
    {code:"33-3051",text:"Police and Sheriff's Patrol Officers"},
    {code:"33-3052",text:"Transit and Railroad Police"},
    {code:"33-9011",text:"Animal Control Workers"},
    {code:"33-9032",text:"Security Guards"},
    {code:"33-9091",text:"Crossing Guards"},
    {code:"33-9092",text:"Lifeguards, Ski Patrol, and Other Recreational Pro"},
    {code:"33-9093",text:"Transportation Security Screeners"},
    {code:"33-9099",text:"Protective Service Workers, All Other"},
    {code:"35-1012",text:"First-Line Supervisors of Food Preparation and Ser"},
    {code:"35-2011",text:"Cooks, Fast Food"},
    {code:"35-2012",text:"Cooks, Institution and Cafeteria"},
    {code:"35-2013",text:"Cooks, Private Household"},
    {code:"35-2014",text:"Cooks, Restaurant"},
    {code:"35-2015",text:"Cooks, Short Order"},
    {code:"35-2019",text:"Cooks, All Other"},
    {code:"35-2021",text:"Food Preparation Workers"},
    {code:"35-3021",text:"Combined Food Preparation and Serving Workers, Inc"},
    {code:"35-3022",text:"Counter Attendants, Cafeteria, Food Concession, an"},
    {code:"35-3031",text:"Waiters and Waitresses"},
    {code:"35-3041",text:"Food Servers, Nonrestaurant"},
    {code:"35-9011",text:"Dining Room and Cafeteria Attendants and Bartender"},
    {code:"35-9021",text:"Dishwashers"},
    {code:"35-9031",text:"Hosts and Hostesses, Restaurant, Lounge, and Coffe"},
    {code:"35-9099",text:"Food Preparation and Serving Related Workers, All"},
    {code:"37-1011",text:"First-Line Supervisors of Housekeeping and Janitor"},
    {code:"37-1012",text:"First-Line Supervisors of Landscaping, Lawn Servic"},
    {code:"37-2011",text:"Janitors and Cleaners, Except Maids and Housekeepi"},
    {code:"37-2012",text:"Maids and Housekeeping Cleaners"},
    {code:"37-2019",text:"Building Cleaning Workers, All Other"},
    {code:"37-2021",text:"Pest Control Workers"},
    {code:"37-3011",text:"Landscaping and Groundskeeping Workers"},
    {code:"37-3012",text:"Pesticide Handlers, Sprayers, and Applicators, Veg"},
    {code:"37-3013",text:"Tree Trimmers and Pruners"},
    {code:"37-3019",text:"Grounds Maintenance Workers, All Other"},
    {code:"39-1012",text:"Slot Supervisors"},
    {code:"39-1021",text:"First-Line Supervisors of Personal Service Workers"},
    {code:"39-2011",text:"Animal Trainers"},
    {code:"39-2021",text:"Nonfarm Animal Caretakers"},
    {code:"39-3021",text:"Motion Picture Projectionists"},
    {code:"39-3031",text:"Ushers, Lobby Attendants, and Ticket Takers"},
    {code:"39-3091",text:"Amusement and Recreation Attendants"},
    {code:"39-3092",text:"Costume Attendants"},
    {code:"39-3093",text:"Locker Room, Coatroom, and Dressing Room Attendant"},
    {code:"39-3099",text:"Entertainment Attendants and Related Workers, All"},
    {code:"39-4021",text:"Funeral Attendants"},
    {code:"39-4031",text:"Morticians, Undertakers, and Funeral Directors"},
    {code:"39-5011",text:"Barbers"},
    {code:"39-5012",text:"Hairdressers, Hairstylists, and Cosmetologists"},
    {code:"39-5091",text:"Makeup Artists, Theatrical and Performance"},
    {code:"39-5092",text:"Manicurists and Pedicurists"},
    {code:"39-5093",text:"Shampooers"},
    {code:"39-5094",text:"Skincare Specialists"},
    {code:"39-6011",text:"Baggage Porters and Bellhops"},
    {code:"39-6012",text:"Concierges"},
    {code:"39-7011",text:"Tour Guides and Escorts"},
    {code:"39-7012",text:"Travel Guides"},
    {code:"39-9011",text:"Childcare Workers"},
    {code:"39-9021",text:"Personal Care Aides"},
    {code:"39-9031",text:"Fitness Trainers and Aerobics Instructors"},
    {code:"39-9032",text:"Recreation Workers"},
    {code:"39-9041",text:"Residential Advisors"},
    {code:"39-9099",text:"Personal Care and Service Workers, All Other"},
    {code:"41-1011",text:"First-Line Supervisors of Retail Sales Workers"},
    {code:"41-1012",text:"First-Line Supervisors of Non-Retail Sales Workers"},
    {code:"41-2021",text:"Counter and Rental Clerks"},
    {code:"41-2022",text:"Parts Salespersons"},
    {code:"41-2031",text:"Retail Salespersons"},
    {code:"41-3011",text:"Advertising Sales Agents"},
    {code:"41-3099",text:"Sales Representatives, Services, All Other"},
    {code:"41-4011",text:"Sales Representatives, Wholesale and Manufacturing"},
    {code:"41-4012",text:"Sales Representatives, Wholesale and Manufacturing"},
    {code:"41-9011",text:"Demonstrators and Product Promoters"},
    {code:"41-9031",text:"Sales Engineers"},
    {code:"41-9041",text:"Telemarketers"},
    {code:"41-9091",text:"Door-to-Door Sales Workers, News and Street Vendor"},
    {code:"41-9099",text:"Sales and Related Workers, All Other"},
    {code:"43-1011",text:"First-Line Supervisors of Office and Administrativ"},
    {code:"43-2011",text:"Switchboard Operators, Including Answering Service"},
    {code:"43-2021",text:"Telephone Operators"},
    {code:"43-2099",text:"Communications Equipment Operators, All Other"},
    {code:"43-3011",text:"Bill and Account Collectors"},
    {code:"43-3021",text:"Billing and Posting Clerks"},
    {code:"43-3031",text:"Bookkeeping, Accounting, and Auditing Clerks"},
    {code:"43-3051",text:"Payroll and Timekeeping Clerks"},
    {code:"43-3061",text:"Procurement Clerks"},
    {code:"43-4021",text:"Correspondence Clerks"},
    {code:"43-4031",text:"Court, Municipal, and License Clerks"},
    {code:"43-4041",text:"Credit Authorizers, Checkers, and Clerks"},
    {code:"43-4051",text:"Customer Service Representatives"},
    {code:"43-4061",text:"Eligibility Interviewers, Government Programs"},
    {code:"43-4071",text:"File Clerks"},
    {code:"43-4081",text:"Hotel, Motel, and Resort Desk Clerks"},
    {code:"43-4111",text:"Interviewers, Except Eligibility and Loan"},
    {code:"43-4121",text:"Library Assistants, Clerical"},
    {code:"43-4131",text:"Loan Interviewers and Clerks"},
    {code:"43-4141",text:"New Accounts Clerks"},
    {code:"43-4151",text:"Order Clerks"},
    {code:"43-4161",text:"Human Resources Assistants, Except Payroll and Tim"},
    {code:"43-4171",text:"Receptionists and Information Clerks"},
    {code:"43-4199",text:"Information and Record Clerks, All Other"},
    {code:"43-5021",text:"Couriers and Messengers"},
    {code:"43-5031",text:"Police, Fire, and Ambulance Dispatchers"},
    {code:"43-5032",text:"Dispatchers, Except Police, Fire, and Ambulance"},
    {code:"43-5041",text:"Meter Readers, Utilities"},
    {code:"43-5051",text:"Postal Service Clerks"},
    {code:"43-5052",text:"Postal Service Mail Carriers"},
    {code:"43-5053",text:"Postal Service Mail Sorters, Processors, and Proce"},
    {code:"43-5061",text:"Production, Planning, and Expediting Clerks"},
    {code:"43-5071",text:"Shipping, Receiving, and Traffic Clerks"},
    {code:"43-5111",text:"Weighers, Measurers, Checkers, and Samplers, Recor"},
    {code:"43-6011",text:"Executive Secretaries and Executive Administrative"},
    {code:"43-6012",text:"Legal Secretaries"},
    {code:"43-6013",text:"Medical Secretaries"},
    {code:"43-6014",text:"Secretaries and Administrative Assistants, Except"},
    {code:"43-9011",text:"Computer Operators"},
    {code:"43-9021",text:"Data Entry Keyers"},
    {code:"43-9022",text:"Word Processors and Typists"},
    {code:"43-9031",text:"Desktop Publishers"},
    {code:"43-9051",text:"Mail Clerks and Mail Machine Operators, Except Pos"},
    {code:"43-9061",text:"Office Clerks, General"},
    {code:"43-9071",text:"Office Machine Operators, Except Computer"},
    {code:"43-9081",text:"Proofreaders and Copy Markers"},
    {code:"43-9111",text:"Statistical Assistants"},
    {code:"43-9199",text:"Office and Administrative Support Workers, All Oth"},
    {code:"45-1011",text:"First-Line Supervisors of Farming, Fishing, and Fo"},
    {code:"45-2011",text:"Agricultural Inspectors"},
    {code:"45-2041",text:"Graders and Sorters, Agricultural Products"},
    {code:"45-2091",text:"Agricultural Equipment Operators"},
    {code:"45-2092",text:"Farmworkers and Laborers, Crop, Nursery, and Green"},
    {code:"45-2093",text:"Farmworkers, Farm, Ranch, and Aquacultural Animals"},
    {code:"45-2099",text:"Agricultural Workers, All Other"},
    {code:"45-3011",text:"Fishers and Related Fishing Workers"},
    {code:"45-3021",text:"Hunters and Trappers"},
    {code:"45-4011",text:"Forest and Conservation Workers"},
    {code:"45-4021",text:"Fallers"},
    {code:"45-4022",text:"Logging Equipment Operators"},
    {code:"45-4023",text:"Log Graders and Scalers"},
    {code:"45-4029",text:"Logging Workers, All Other"},
    {code:"47-2011",text:"Boilermakers"},
    {code:"47-2021",text:"Brickmasons and Blockmasons"},
    {code:"47-2022",text:"Stonemasons"},
    {code:"47-2031",text:"Carpenters"},
    {code:"47-2041",text:"Carpet Installers"},
    {code:"47-2042",text:"Floor Layers, Except Carpet, Wood, and Hard Tiles"},
    {code:"47-2043",text:"Floor Sanders and Finishers"},
    {code:"47-2044",text:"Tile and Marble Setters"},
    {code:"47-2051",text:"Cement Masons and Concrete Finishers"},
    {code:"47-2053",text:"Terrazzo Workers and Finishers"},
    {code:"47-2072",text:"Pile-Driver Operators"},
    {code:"47-2081",text:"Drywall and Ceiling Tile Installers"},
    {code:"47-2082",text:"Tapers"},
    {code:"47-2111",text:"Electricians"},
    {code:"47-2121",text:"Glaziers"},
    {code:"47-2131",text:"Insulation Workers, Floor, Ceiling, and Wall"},
    {code:"47-2132",text:"Insulation Workers, Mechanical"},
    {code:"47-2142",text:"Paperhangers"},
    {code:"47-2151",text:"Pipelayers"},
    {code:"47-2161",text:"Plasterers and Stucco Masons"},
    {code:"47-2171",text:"Reinforcing Iron and Rebar Workers"},
    {code:"47-2181",text:"Roofers"},
    {code:"47-2211",text:"Sheet Metal Workers"},
    {code:"47-2221",text:"Structural Iron and Steel Workers"},
    {code:"47-2231",text:"Solar Photovoltaic Installers"},
    {code:"47-3011",text:"Helpers--Brickmasons, Blockmasons, Stonemasons, an"},
    {code:"47-3012",text:"Helpers--Carpenters"},
    {code:"47-3013",text:"Helpers--Electricians"},
    {code:"47-3014",text:"Helpers--Painters, Paperhangers, Plasterers, and S"},
    {code:"47-3015",text:"Helpers--Pipelayers, Plumbers, Pipefitters, and St"},
    {code:"47-3016",text:"Helpers--Roofers"},
    {code:"47-3019",text:"Helpers, Construction Trades, All Other"},
    {code:"47-4021",text:"Elevator Installers and Repairers"},
    {code:"47-4031",text:"Fence Erectors"},
    {code:"47-4041",text:"Hazardous Materials Removal Workers"},
    {code:"47-4051",text:"Highway Maintenance Workers"},
    {code:"47-4061",text:"Rail-Track Laying and Maintenance Equipment Operat"},
    {code:"47-4071",text:"Septic Tank Servicers and Sewer Pipe Cleaners"},
    {code:"47-4091",text:"Segmental Pavers"},
    {code:"47-5042",text:"Mine Cutting and Channeling Machine Operators"},
    {code:"47-5051",text:"Rock Splitters, Quarry"},
    {code:"47-5081",text:"Helpers--Extraction Workers"},
    {code:"49-1011",text:"First-Line Supervisors of Mechanics, Installers, a"},
    {code:"49-2021",text:"Radio, Cellular, and Tower Equipment Installers an"},
    {code:"49-2022",text:"Telecommunications Equipment Installers and Repair"},
    {code:"49-2091",text:"Avionics Technicians"},
    {code:"49-2093",text:"Electrical and Electronics Installers and Repairer"},
    {code:"49-2094",text:"Electrical and Electronics Repairers, Commercial a"},
    {code:"49-2095",text:"Electrical and Electronics Repairers, Powerhouse,"},
    {code:"49-2096",text:"Electronic Equipment Installers and Repairers, Mot"},
    {code:"49-2097",text:"Electronic Home Entertainment Equipment Installers"},
    {code:"49-2098",text:"Security and Fire Alarm Systems Installers"},
    {code:"49-3011",text:"Aircraft Mechanics and Service Technicians"},
    {code:"49-3021",text:"Automotive Body and Related Repairers"},
    {code:"49-3022",text:"Automotive Glass Installers and Repairers"},
    {code:"49-3023",text:"Automotive Service Technicians and Mechanics"},
    {code:"49-3031",text:"Bus and Truck Mechanics and Diesel Engine Speciali"},
    {code:"49-3041",text:"Farm Equipment Mechanics and Service Technicians"},
    {code:"49-3042",text:"Mobile Heavy Equipment Mechanics, Except Engines"},
    {code:"49-3043",text:"Rail Car Repairers"},
    {code:"49-3051",text:"Motorboat Mechanics and Service Technicians"},
    {code:"49-3052",text:"Motorcycle Mechanics"},
    {code:"49-3053",text:"Outdoor Power Equipment and Other Small Engine Mec"},
    {code:"49-3091",text:"Bicycle Repairers"},
    {code:"49-3092",text:"Recreational Vehicle Service Technicians"},
    {code:"49-3093",text:"Tire Repairers and Changers"},
    {code:"49-9011",text:"Mechanical Door Repairers"},
    {code:"49-9012",text:"Control and Valve Installers and Repairers, Except"},
    {code:"49-9021",text:"Heating, Air Conditioning, and Refrigeration Mecha"},
    {code:"49-9031",text:"Home Appliance Repairers"},
    {code:"49-9041",text:"Industrial Machinery Mechanics"},
    {code:"49-9043",text:"Maintenance Workers, Machinery"},
    {code:"49-9044",text:"Millwrights"},
    {code:"49-9045",text:"Refractory Materials Repairers, Except Brickmasons"},
    {code:"49-9051",text:"Electrical Power-Line Installers and Repairers"},
    {code:"49-9052",text:"Telecommunications Line Installers and Repairers"},
    {code:"49-9061",text:"Camera and Photographic Equipment Repairers"},
    {code:"49-9062",text:"Medical Equipment Repairers"},
    {code:"49-9063",text:"Musical Instrument Repairers and Tuners"},
    {code:"49-9069",text:"Precision Instrument and Equipment Repairers, All"},
    {code:"49-9071",text:"Maintenance and Repair Workers, General"},
    {code:"49-9081",text:"Wind Turbine Service Technicians"},
    {code:"49-9092",text:"Commercial Divers"},
    {code:"49-9093",text:"Fabric Menders, Except Garment"},
    {code:"49-9094",text:"Locksmiths and Safe Repairers"},
    {code:"49-9095",text:"Manufactured Building and Mobile Home Installers"},
    {code:"49-9096",text:"Riggers"},
    {code:"49-9097",text:"Signal and Track Switch Repairers"},
    {code:"49-9098",text:"Helpers--Installation, Maintenance, and Repair Wor"},
    {code:"49-9099",text:"Installation, Maintenance, and Repair Workers, All"},
    {code:"51-1011",text:"First-Line Supervisors of Production and Operating"},
    {code:"51-2011",text:"Aircraft Structure, Surfaces, Rigging, and Systems"},
    {code:"51-2021",text:"Coil Winders, Tapers, and Finishers"},
    {code:"51-2022",text:"Electrical and Electronic Equipment Assemblers"},
    {code:"51-2023",text:"Electromechanical Equipment Assemblers"},
    {code:"51-2031",text:"Engine and Other Machine Assemblers"},
    {code:"51-2041",text:"Structural Metal Fabricators and Fitters"},
    {code:"51-2091",text:"Fiberglass Laminators and Fabricators"},
    {code:"51-2092",text:"Team Assemblers"},
    {code:"51-2093",text:"Timing Device Assemblers and Adjusters"},
    {code:"51-2099",text:"Assemblers and Fabricators, All Other"},
    {code:"51-3011",text:"Bakers"},
    {code:"51-3021",text:"Butchers and Meat Cutters"},
    {code:"51-3022",text:"Meat, Poultry, and Fish Cutters and Trimmers"},
    {code:"51-3023",text:"Slaughterers and Meat Packers"},
    {code:"51-3091",text:"Food and Tobacco Roasting, Baking, and Drying Mach"},
    {code:"51-3092",text:"Food Batchmakers"},
    {code:"51-3093",text:"Food Cooking Machine Operators and Tenders"},
    {code:"51-3099",text:"Food Processing Workers, All Other"},
    {code:"51-4011",text:"Computer-Controlled Machine Tool Operators, Metal"},
    {code:"51-4012",text:"Computer Numerically Controlled Machine Tool Progr"},
    {code:"51-4021",text:"Extruding and Drawing Machine Setters, Operators,"},
    {code:"51-4022",text:"Forging Machine Setters, Operators, and Tenders, M"},
    {code:"51-4023",text:"Rolling Machine Setters, Operators, and Tenders, M"},
    {code:"51-4031",text:"Cutting, Punching, and Press Machine Setters, Oper"},
    {code:"51-4033",text:"Grinding, Lapping, Polishing, and Buffing Machine"},
    {code:"51-4034",text:"Lathe and Turning Machine Tool Setters, Operators,"},
    {code:"51-4035",text:"Milling and Planing Machine Setters, Operators, an"},
    {code:"51-4041",text:"Machinists"},
    {code:"51-4051",text:"Metal-Refining Furnace Operators and Tenders"},
    {code:"51-4052",text:"Pourers and Casters, Metal"},
    {code:"51-4061",text:"Model Makers, Metal and Plastic"},
    {code:"51-4062",text:"Patternmakers, Metal and Plastic"},
    {code:"51-4071",text:"Foundry Mold and Coremakers"},
    {code:"51-4072",text:"Molding, Coremaking, and Casting Machine Setters,"},
    {code:"51-4081",text:"Multiple Machine Tool Setters, Operators, and Tend"},
    {code:"51-4111",text:"Tool and Die Makers"},
    {code:"51-4191",text:"Heat Treating Equipment Setters, Operators, and Te"},
    {code:"51-4192",text:"Layout Workers, Metal and Plastic"},
    {code:"51-4193",text:"Plating and Coating Machine Setters, Operators, an"},
    {code:"51-4194",text:"Tool Grinders, Filers, and Sharpeners"},
    {code:"51-4199",text:"Metal Workers and Plastic Workers, All Other"},
    {code:"51-5111",text:"Prepress Technicians and Workers"},
    {code:"51-5112",text:"Printing Press Operators"},
    {code:"51-5113",text:"Print Binding and Finishing Workers"},
    {code:"51-6011",text:"Laundry and Dry-Cleaning Workers"},
    {code:"51-6021",text:"Pressers, Textile, Garment, and Related Materials"},
    {code:"51-6031",text:"Sewing Machine Operators"},
    {code:"51-6041",text:"Shoe and Leather Workers and Repairers"},
    {code:"51-6042",text:"Shoe Machine Operators and Tenders"},
    {code:"51-6051",text:"Sewers, Hand"},
    {code:"51-6052",text:"Tailors, Dressmakers, and Custom Sewers"},
    {code:"51-6061",text:"Textile Bleaching and Dyeing Machine Operators and"},
    {code:"51-6062",text:"Textile Cutting Machine Setters, Operators, and Te"},
    {code:"51-6063",text:"Textile Knitting and Weaving Machine Setters, Oper"},
    {code:"51-6064",text:"Textile Winding, Twisting, and Drawing Out Machine"},
    {code:"51-6091",text:"Extruding and Forming Machine Setters, Operators,"},
    {code:"51-6092",text:"Fabric and Apparel Patternmakers"},
    {code:"51-6093",text:"Upholsterers"},
    {code:"51-6099",text:"Textile, Apparel, and Furnishings Workers, All Oth"},
    {code:"51-7011",text:"Cabinetmakers and Bench Carpenters"},
    {code:"51-7021",text:"Furniture Finishers"},
    {code:"51-7031",text:"Model Makers, Wood"},
    {code:"51-7032",text:"Patternmakers, Wood"},
    {code:"51-7041",text:"Sawing Machine Setters, Operators, and Tenders, Wo"},
    {code:"51-7042",text:"Woodworking Machine Setters, Operators, and Tender"},
    {code:"51-7099",text:"Woodworkers, All Other"},
    {code:"51-8012",text:"Power Distributors and Dispatchers"},
    {code:"51-8013",text:"Power Plant Operators"},
    {code:"51-8021",text:"Stationary Engineers and Boiler Operators"},
    {code:"51-8031",text:"Water and Wastewater Treatment Plant and System Op"},
    {code:"51-8091",text:"Chemical Plant and System Operators"},
    {code:"51-8099",text:"Plant and System Operators, All Other"},
    {code:"51-9011",text:"Chemical Equipment Operators and Tenders"},
    {code:"51-9012",text:"Separating, Filtering, Clarifying, Precipitating,"},
    {code:"51-9021",text:"Crushing, Grinding, and Polishing Machine Setters,"},
    {code:"51-9022",text:"Grinding and Polishing Workers, Hand"},
    {code:"51-9023",text:"Mixing and Blending Machine Setters, Operators, an"},
    {code:"51-9031",text:"Cutters and Trimmers, Hand"},
    {code:"51-9032",text:"Cutting and Slicing Machine Setters, Operators, an"},
    {code:"51-9041",text:"Extruding, Forming, Pressing, and Compacting Machi"},
    {code:"51-9051",text:"Furnace, Kiln, Oven, Drier, and Kettle Operators a"},
    {code:"51-9061",text:"Inspectors, Testers, Sorters, Samplers, and Weighe"},
    {code:"51-9081",text:"Dental Laboratory Technicians"},
    {code:"51-9082",text:"Medical Appliance Technicians"},
    {code:"51-9083",text:"Ophthalmic Laboratory Technicians"},
    {code:"51-9111",text:"Packaging and Filling Machine Operators and Tender"},
    {code:"51-9121",text:"Coating, Painting, and Spraying Machine Setters, O"},
    {code:"51-9122",text:"Painters, Transportation Equipment"},
    {code:"51-9123",text:"Painting, Coating, and Decorating Workers"},
    {code:"51-9141",text:"Semiconductor Processors"},
    {code:"51-9151",text:"Photographic Process Workers and Processing Machin"},
    {code:"51-9191",text:"Adhesive Bonding Machine Operators and Tenders"},
    {code:"51-9192",text:"Cleaning, Washing, and Metal Pickling Equipment Op"},
    {code:"51-9193",text:"Cooling and Freezing Equipment Operators and Tende"},
    {code:"51-9194",text:"Etchers and Engravers"},
    {code:"51-9195",text:"Molders, Shapers, and Casters, Except Metal and Pl"},
    {code:"51-9196",text:"Paper Goods Machine Setters, Operators, and Tender"},
    {code:"51-9197",text:"Tire Builders"},
    {code:"51-9198",text:"Helpers--Production Workers"},
    {code:"51-9199",text:"Production Workers, All Other"},
    {code:"53-1021",text:"First-Line Supervisors of Helpers, Laborers, and M"},
    {code:"53-1031",text:"First-Line Supervisors of Transportation and Mater"},
    {code:"53-2021",text:"Air Traffic Controllers"},
    {code:"53-2022",text:"Airfield Operations Specialists"},
    {code:"53-3011",text:"Ambulance Drivers and Attendants, Except Emergency"},
    {code:"53-3021",text:"Bus Drivers, Transit and Intercity"},
    {code:"53-3022",text:"Bus Drivers, School or Special Client"},
    {code:"53-3031",text:"Driver\/Sales Workers"},
    {code:"53-3033",text:"Light Truck or Delivery Services Drivers"},
    {code:"53-3099",text:"Motor Vehicle Operators, All Other"},
    {code:"53-4011",text:"Locomotive Engineers"},
    {code:"53-4012",text:"Locomotive Firers"},
    {code:"53-4013",text:"Rail Yard Engineers, Dinkey Operators, and Hostler"},
    {code:"53-4021",text:"Railroad Brake, Signal, and Switch Operators"},
    {code:"53-4031",text:"Railroad Conductors and Yardmasters"},
    {code:"53-4041",text:"Subway and Streetcar Operators"},
    {code:"53-4099",text:"Rail Transportation Workers, All Other"},
    {code:"53-5031",text:"Ship Engineers"},
    {code:"53-6011",text:"Bridge and Lock Tenders"},
    {code:"53-6021",text:"Parking Lot Attendants"},
    {code:"53-6031",text:"Automotive and Watercraft Service Attendants"},
    {code:"53-6041",text:"Traffic Technicians"},
    {code:"53-6051",text:"Transportation Inspectors"},
    {code:"53-7011",text:"Conveyor Operators and Tenders"},
    {code:"53-7021",text:"Crane and Tower Operators"},
    {code:"53-7031",text:"Dredge Operators"},
    {code:"53-7032",text:"Excavating and Loading Machine and Dragline Operat"},
    {code:"53-7051",text:"Industrial Truck and Tractor Operators"},
    {code:"53-7061",text:"Cleaners of Vehicles and Equipment"},
    {code:"53-7063",text:"Machine Feeders and Offbearers"},
    {code:"53-7064",text:"Packers and Packagers, Hand"},
    {code:"53-7072",text:"Pump Operators, Except Wellhead Pumpers"},
    {code:"53-7081",text:"Refuse and Recyclable Material Collectors"},
    {code:"53-7199",text:"Material Moving Workers, All Other"},
    {code:"55-1012",text:"Aircraft Launch and Recovery Officers"},
    {code:"55-1013",text:"Armored Assault Vehicle Officers"},
    {code:"55-1014",text:"Artillery and Missile Officers"},
    {code:"55-1015",text:"Command and Control Center Officers"},
    {code:"55-2012",text:"First-Line Supervisors of Weapons Specialists\/Crew"},
    {code:"55-2013",text:"First-Line Supervisors of All Other Tactical Opera"},
    {code:"55-3012",text:"Aircraft Launch and Recovery Specialists"},
    {code:"55-3013",text:"Armored Assault Vehicle Crew Members"},
    {code:"55-3014",text:"Artillery and Missile Crew Members"},
    {code:"55-3015",text:"Command and Control Center Specialists"},
    {code:"55-3017",text:"Radar and Sonar Technicians"},
    {code:"STUDENT",text:"Student"},
    {code:"RETIRED",text:"Retired"},
];
occupations = occupations.sort((a, b) => a.text.localeCompare(b.text));
const OccupationSelect = ({ selectedValue, onChange }) => {
    return (
        <select
          className="form-control no-icon"
          value={selectedValue}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">Select Occupation</option>
          {occupations.map((occ) => (
            <option key={occ.code} value={occ.code}>
              {occ.text}
            </option>
          ))}
        </select>
      );
};

export default OccupationSelect;
